import type { DataLayerEvent} from '@magpie/ui-core';
import { DataLayerService } from '@magpie/ui-core';
import addSessionIdToEvent from './addSessionIdToEvent';

export type PaymentProviderName = 'KlarnaExpress' | 'ApplePayExpress' | 'PaypalExpress';

export const pushPaymentProviderSelectionEvent = (providerName: PaymentProviderName, useMmSessionId: boolean) => {
    let eventPayload: DataLayerEvent = {
        event: 'analyticsEvent',
        eventCategory: 'ecommerce',
        eventAction: 'choose_payment_method',
        eventLabel: providerName,
        eventNonInteraction: false,
    };

    if (useMmSessionId === true) {
        eventPayload = addSessionIdToEvent(eventPayload);
    }

    DataLayerService.addEvent<DataLayerEvent>(eventPayload);
};
